
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import HoriSlide from "@/components/horiSlide/HoriSlide.vue";
import { getFarmingDetail } from "../../../../api/farmer";
import { dataType, farmingDetailType } from "./stateType";
import { Router, useRoute, useRouter } from "vue-router";
import { previewImage } from "@/utils/util";

const states: dataType = {
  farmingId: "",
  farmingDetailData: {},
  sourceId: "",
};

export default defineComponent({
  setup() {
    const state = reactive<dataType>(states);
    const { getFarmingDetailData } = useNetwork(state);
    const $route = useRoute();
    const query = $route.query;
    const params = $route.params;
    const $router = useRouter();
    const { onRecord, preview } = useEvent(state, $router);
    onMounted(() => {
      if (params.id) {
        state.farmingId = params.id as string;
      } else {
        state.farmingId = query.id as string;
      }
      state.sourceId = query.sourceId as string;
      getFarmingDetailData();
    });
    return {
      ...toRefs(state),
      onRecord,
      preview,
    };
  },
  components: {
    HoriSlide,
  },
});

// 事件相关hooks
const useEvent = (state: dataType, router?: Router) => {
  const onRecord = () => {
    if (
      state.farmingDetailData.status === 1 &&
      !state.farmingDetailData.optionRecordId
    ) {
      state.farmingDetailData.optionRecordId = state.farmingDetailData.recordId;
    }
    router &&
      router.push({
        path: "/updateFarming",
        query: {
          item: JSON.stringify(state.farmingDetailData),
        },
      });
  };
  const preview = (e: any, i: number) => {
    previewImage(e, i);
  };
  return {
    onRecord,
    preview,
  };
};

// 接口相关hooks
const useNetwork = (state: dataType) => {
  const getFarmingDetailData = async () => {
    const result: any = await getFarmingDetail({ id: state.farmingId });
    if (result.data.code == 0) {
      const tempData: farmingDetailType = result.data.data;
      tempData.plantFarmingImgList = [];
      tempData.phaseImgList = [];
      const phaseList = tempData.phaseImg ? tempData.phaseImg.split(",") : [];
      if (tempData.phaseImg) {
        tempData.phaseImgList = phaseList;
      }
      const plantList = tempData.plantFarmingImg
        ? tempData.plantFarmingImg.split(",")
        : [];
      if (tempData.plantFarmingImg) {
        tempData.plantFarmingImgList = plantList;
      }
      state.farmingDetailData = tempData;
    }
  };
  return {
    getFarmingDetailData,
  };
};
